"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetedEventsTracker = void 0;
const TargetedEventsTracker = (trackersMap) => {
    const trackWithTarget = async (event, target) => {
        var _a;
        await ((_a = trackersMap.get(target)) === null || _a === void 0 ? void 0 : _a.track(event));
    };
    const trackWithTargets = async (event, targets) => {
        var _a;
        for (const target of targets) {
            await ((_a = trackersMap.get(target)) === null || _a === void 0 ? void 0 : _a.track(event));
        }
    };
    const track = async (event) => {
        await trackWithTargets(event, Array.from(trackersMap.keys()));
    };
    return {
        track,
        trackWithTarget,
        trackWithTargets,
    };
};
exports.TargetedEventsTracker = TargetedEventsTracker;
